var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConfighistoryHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_confighistory_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_confighistory_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,8 L14,8 L14,9.5 L7,9.5 L7,8 Z M7,5.5 L14,5.5 L14,7 L7,7 L7,5.5 Z M7,10.5 L14,10.5 L14,12 L7,12 L7,10.5 Z M2,0 C0.9,0 -6.36660169e-12,0.9 -6.36660169e-12,2 L-6.36660169e-12,15 C-6.36660169e-12,16.1 0.9,17 2,17 L15,17 C16.1,17 17,16.1 17,15 L17,2 C17,0.9 16.1,0 15,0 L2,0 Z M15,15 L6,15 L6,2 L15,2 L15,15 L15,15 Z",
    id: "Shape-Copy-6",
    fill: "#A3AFB7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfighistoryHover);
export default __webpack_public_path__ + "static/media/icon_confighistory_hover.82f522c13e25d2bfab398680b2a4dff3.svg";
export { ForwardRef as ReactComponent };